
import {  AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { NgxSpinnerService } from 'ngx-spinner';
import { ErrorService } from 'src/app/shared/services/errors.service';
import { GetPermisses } from 'src/app/web/util/formatDataTable';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-create-project',
  templateUrl: './create-project.component.html',
  styleUrls: ['./create-project.component.scss']
})
export class CreateProjectComponent implements  AfterViewInit, OnDestroy, OnInit  {

  @ViewChild(DataTableDirective, {static: false})
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtOptions2: DataTables.Settings = {};
  annex: any[] = []
  permiso: number[] = []
  annexForm: FormGroup;
  step:number = 0
  title="Datos"
  idProject
  crud='create';
  permisoOptionAdminTeam = true;
  permisoContractAnnex = true;
  permisoOptionAdmin = true;

  constructor(
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private router: Router,
    private route: ActivatedRoute,
    private errorService: ErrorService,
  ) { 
    this.route.params.subscribe((params) => {
      this.idProject = params['id'];
      this.step = params['step'];
    });
    this.route.url.subscribe((params)=>{
    this.crud=params[1].path
    })
  }

  ngOnInit(): void {

    if(this.crud == "edit"){

      this.permisoOptionAdminTeam = GetPermisses(5);
      this.permisoContractAnnex = GetPermisses(8);
      this.permisoOptionAdmin = GetPermisses(4);

      if(!this.permisoOptionAdmin && !this.permisoOptionAdminTeam && !this.permisoContractAnnex){
        this.router.navigate(['/pdg/home']);
      }else if(this.permisoOptionAdmin){
      
      }else if(!this.permisoOptionAdminTeam && this.step == 3){
        this.router.navigate(['/pdg/home']);
      }else if(this.permisoOptionAdminTeam && this.step != 3){
        this.router.navigate(['/pdg/home']);
      }else if(!this.permisoContractAnnex && this.step == 4){
        this.router.navigate(['/pdg/home']);
      }else if(this.permisoContractAnnex && this.step != 4){
        this.router.navigate(['/pdg/home']);
      }

    }

    // this.permiso = this.errorService.getPermisses();
    // if (this.permiso.find(element => element == 2) && this.crud == "create") {
    // } else if (this.permiso.find(element => element == 3 ) && this.crud == "edit") {
    // } else {
    //   this.errorService.error2(403)
    // }
   
    
  }

 
  valor(i:number){
    if(this.idProject != "null"){

      this.router.navigate(['/pdg/project/'+this.crud+'/'+this.idProject+'/'+i]);
      if(i == 1){
      this.title = "Datos"
    }
    else if (i == 2){
      this.title = "Etapas"
    }
    else if (i == 3){
      this.title = "Equipo"
    }
    else if (i == 4){
      this.title = "Anexos"
    }
    else if (i == 5){
      this.title = "Configuraciones"
    }
    }
    if(this.idProject == "null" && i != 1 ){
      Swal.fire({title:"Primero debes completar la primera etapa.",text: '',icon: 'error',heightAuto: false});
      var form = document.getElementsByClassName('needs-validation')[0] as HTMLFormElement;
      if (form.checkValidity() === false) {
        form.classList.add('was-validated');
      } 
    }
    
  }

  volver(){
    if(this.crud =='create'){
      this.router.navigate(['/pdg/project/creating'])
    }else{
      this.router.navigate(['/pdg/project/list'])
    }
  }
 
    ngAfterViewInit(): void {
    
  }

  ngOnDestroy(): void {
    
  }

  rerender(): void {
    
    
  }
}
